import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Home, Phone, Mail } from 'lucide-react';
import { SEO } from '../utils/seo';
export function ContactPage() {
  return <div className="min-h-screen bg-white" data-id="element-320">
      <SEO title="Contact" description="Contactez l'ARIH Agadir Souss Massa - Imm. oumlil N°7 av. Hassan II Agadir - Téléphone: +212 5 28 826 191" keywords="contact ARIH, Agadir contact, hôtellerie Agadir contact" data-id="element-321" />
      <Navbar data-id="element-322" />

      {/* Header Section */}
      <section className="bg-white py-20 px-4 md:px-8" data-id="element-323">
        <div className="container mx-auto text-center" data-id="element-324">
          <h2 className="text-[40px] md:text-[48px] font-bold text-arih-dark mb-6" data-id="element-325">
            Besoin d'assistance ?
          </h2>
          <p className="text-[18px] text-arih-gray max-w-2xl mx-auto leading-[32px]" data-id="element-326">
            Que ce soit pour une question spécifique, une demande particulière
            ou simplement un conseil, n'hésitez pas à nous contacter par
            téléphone ou via le formulaire.
          </p>
        </div>
      </section>

      {/* Split Section */}
      <section className="grid grid-cols-1 md:grid-cols-2" data-id="element-327">
        {/* Left - Contact Info */}
        <div className="bg-arih-blue text-white p-12 md:p-20" data-id="element-328">
          <h3 className="text-[28px] font-bold mb-8" data-id="element-329">Coordonnées</h3>

          <div className="space-y-8" data-id="element-330">
            <div data-id="element-331">
              <div className="flex items-start gap-4" data-id="element-332">
                <Home className="h-6 w-6 mt-1 flex-shrink-0" data-id="element-333" />
                <div data-id="element-334">
                  <p className="text-[14px] text-white/70 mb-1" data-id="element-335">Adresse</p>
                  <p className="text-[18px] font-semibold" data-id="element-336">
                    Imm. oumlil N°7 av. Hassan II Agadir
                  </p>
                </div>
              </div>
            </div>

            <div data-id="element-337">
              <div className="flex items-start gap-4" data-id="element-338">
                <Phone className="h-6 w-6 mt-1 flex-shrink-0" data-id="element-339" />
                <div data-id="element-340">
                  <p className="text-[14px] text-white/70 mb-1" data-id="element-341">Téléphone</p>
                  <a href="tel:+212528826191" className="text-[18px] font-semibold hover:underline" data-id="element-342">
                    +212 5 28 826 191
                  </a>
                </div>
              </div>
            </div>

            <div data-id="element-343">
              <div className="flex items-start gap-4" data-id="element-344">
                <Mail className="h-6 w-6 mt-1 flex-shrink-0" data-id="element-345" />
                <div data-id="element-346">
                  <p className="text-[14px] text-white/70 mb-1" data-id="element-347">Email</p>
                  <a href="mailto:aihaagadir@gmail.com" className="text-[18px] font-semibold hover:underline" data-id="element-348">
                    aihaagadir@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right - Form */}
        <div className="bg-white p-12 md:p-16" data-id="element-349">
          <h3 className="text-[28px] font-bold text-arih-dark mb-8" data-id="element-350">
            Envoyer un Message
          </h3>

          <form className="space-y-6" data-id="element-351">
            <div data-id="element-352">
              <label className="block text-[14px] font-semibold text-arih-dark mb-2" data-id="element-353">
                Nom complet
              </label>
              <Input type="text" className="w-full border border-gray-300 rounded-lg px-4 py-3 text-[16px] focus:border-arih-blue" data-id="element-354" />
            </div>

            <div data-id="element-355">
              <label className="block text-[14px] font-semibold text-arih-dark mb-2" data-id="element-356">
                Email
              </label>
              <Input type="email" className="w-full border border-gray-300 rounded-lg px-4 py-3 text-[16px] focus:border-arih-blue" data-id="element-357" />
            </div>

            <div data-id="element-358">
              <label className="block text-[14px] font-semibold text-arih-dark mb-2" data-id="element-359">
                Sujet
              </label>
              <Input type="text" className="w-full border border-gray-300 rounded-lg px-4 py-3 text-[16px] focus:border-arih-blue" data-id="element-360" />
            </div>

            <div data-id="element-361">
              <label className="block text-[14px] font-semibold text-arih-dark mb-2" data-id="element-362">
                Message
              </label>
              <textarea rows={5} className="w-full border border-gray-300 rounded-lg px-4 py-3 text-[16px] focus:border-arih-blue focus:outline-none focus:ring-2 focus:ring-arih-blue/20" data-id="element-363" />
            </div>

            <Button type="submit" className="w-full bg-arih-blue text-white rounded-full px-10 py-3.5 h-auto text-[16px] font-semibold hover:bg-blue-800 transition-colors" data-id="element-364">
              Envoyer le message
            </Button>
          </form>
        </div>
      </section>

      <Footer data-id="element-365" />
    </div>;
}